import ContactForm from '../../../Contact/ContactForm';

import {
    Dialog, DialogContent, DialogActions, Button, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ContactDialog = ({ open, setData }) => {
    const handleClose = () => {
        setData(e => ({ ...e, dialog2: false }));
    };

    return (
        <Dialog open={ open }
            onClose={ handleClose }>
            <IconButton
                aria-label="close"
                onClick={ handleClose }
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <ContactForm
                    txt={ '¿Deseas conocer el estatus de tu pedido?' }
                />
            </DialogContent>
            <DialogActions>
                <Button autoFocus variant='contained'
                    onClick={ () => setData(e => ({ ...e, dialog2: false, dialog1: true })) }>
                    Proceder al pago
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContactDialog;